module.exports = __webpack_public_path__ + "img/P150T_weapon_133.e0a5fd88.png";